import React, { useEffect, useRef, useState } from "react";
import Loaders from "../Loaders";
import HeaderTop from "../HeaderTop";
import Menus from "../Menus";
import Footers from "../Footers";
import '../../../libs/css/bootstrap.min3.3.7.css';
import '../../../libs/css/sweetalert2.min.css';
import { API_ROUTES } from "../../../utils/constants";
import Nulls from "../Nulls";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import UnSubscriptionTable from "./UnSubscriptionTable";
import Swal from "sweetalert2";


export default function UnSubscription(props){
    const {objectToFormData, errorFunction, Helmet, capitalizeWords, isAuthExpired, today, resetTimeToMidnight, resetTimeToB4Midnight, formatDate, allCPs, isLoading1 } = props;

    // console.log("allCPssssaa");
    // console.log(allCPs);

    useEffect(() => {document.title = "UnSubscription | Forthsoft"}, []);

    const [isLoading, setIsLoading] = useState(true);
    const [dataTotal, setDataTotal] = useState(0);
    const [dataList, setDataList] = useState([]);
    const [columns, setColumns] = useState([]);
    const [page, setPage] = useState(1);
    const countPerPage = 20;
    const [isFade, setIsFade] = useState(true);
    const [cpSelected, setCpSelected] = useState('');
    const [registerName, setRegisterName] = useState('service');
    const clearInputs = useRef(null);
    const [allSessions, setAllSessions] = useState([]);

    const networkData = [
        { id: "1", name: "MTN" },
        { id: "2", name: "GLO" },
        { id: "3", name: "AIRTEL" },
        { id: "4", name: "9MOBILE" },
    ];


    const columns1 = [
        {   
            name: 'Bearer ID',
            selector: row => row.bearerId ? capitalizeWords(row.bearerId) : <Nulls />,
            sortable: true,
        },
        {
            name: 'Counts',
            selector: row => row.count ? row.count.toLocaleString() : <Nulls />,
            sortable: true,
        },
    ];


    useEffect(() => {
        setColumns(columns1);
    }, []);

    const userData = JSON.parse(localStorage.getItem('userDataFs'));

    const getAllSessions = async () => {
        try {
            const dataString = {
                page: 1,
                per_page: 1000,
            };
            const response = await fetch(API_ROUTES.VIEW_CP_SERVICES, {
                method: "POST",
                body: objectToFormData(dataString),
                headers: { token: userData?.responseDetails?.token },
            });
            const responseJSON = await response.json();
            isAuthExpired(responseJSON);

            if (responseJSON.status.toString() === "200") {
                const responseData = responseJSON.data;

                const uniqueServices = Array.from(
                    new Map(
                        responseData.map((item) => [
                            item.serviceId,
                            {
                                serviceId: item.serviceId,
                                serviceName: String(item.serviceId) === "10015" ? "Mobibox" : item.serviceName,
                                network_id: item.network_id,
                            },
                        ])
                    ).values()
                ).sort((a, b) => a.serviceName.localeCompare(b.serviceName));

                setAllSessions(uniqueServices);
            }
        } catch (error) {
            console.log("Error getting data: ", error);
            setAllSessions([]);
        }
    };

    const getData = async (isLoad=true, myFilters) => {
        const extractID = myFilters.cp_id.split("|")[0];
        const extractCP = myFilters.cp_id.split("|")[1];
        setCpSelected(extractCP);

        let dataString = {};
        if(myFilters){
            dataString = {
                cp_id: myFilters.cp_id ? extractID > 0 ? extractID : '' : '',
                fro: myFilters.fro,
                to: myFilters.to,
            };

            // Add optional network_id and serviceId if provided
            if (myFilters.network_id) {
                dataString.network_id = myFilters.network_id;
            }
            if (myFilters.serviceId) {
                dataString.serviceId = myFilters.serviceId;
            }
        }else{
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            dataString = {
                cp_id: myFilters.cp_id ? extractID > 0 ? extractID : '' : '',
                fro: resetTimeToMidnight(formatDate(yesterday)),
                to: resetTimeToB4Midnight(formatDate(yesterday)),
            };
        }

        // console.log("chibobo");
        // console.log(dataString);
        setIsFade(true);
        try {
            const response = await fetch(API_ROUTES.UNSUBSCRIPTION, {
                method: "POST",
                body: objectToFormData(dataString),
                headers: {'token': userData?.responseDetails?.token},
            });
            const responseJSON = await response.json();
            isAuthExpired(responseJSON); // check for expired login

            if (responseJSON.status.toString() === "200") {

                // console.log("responseJSON===");
                // console.log(responseJSON);

                const responseData = responseJSON.data;
                const totalData = responseData.length;
                setDataTotal(totalData);
                setDataList(responseData);
                setIsLoading(false);
                setIsFade(false);

                // Clear services form but keep games state
                if (clearInputs.current?.clearServices) {
                    clearInputs.current.clearServices();
                }
            }else{
                setDataTotal(0);
                setDataList([]);
                setIsLoading(false);
                setIsFade(false);
            }
        } catch (error) {
            console.log('Error getting data: ', error);
            setDataTotal(0);
            setDataList([]);
            setIsLoading(false);
            setIsFade(false);
        }
    }

    useEffect(() => {
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        getData(true, { cp_id: "", fro: resetTimeToMidnight(formatDate(yesterday)), to: resetTimeToB4Midnight(formatDate(yesterday)) });
        getAllSessions();
    }, [page]);

    
    const handleDuration = async (data) => {
        // console.log(data);
        if(data.cp_id === ""){
            Swal.fire({
                title: "Error",
                text: "Please select a CP",
                icon: "error",
            });
            return;
        }

        let dataString = {
            cp_id: data.cp_id,
            fro: data.fro + " 00:00:00",
            to: data.to + " 23:59:59",
        };

        // Add optional network_id and serviceId if provided
        if (data.network_id) {
            dataString.network_id = data.network_id;
        }
        if (data.serviceId) {
            dataString.serviceId = data.serviceId;
        }

        getData(true, dataString);
    }



    return (
        <>
            {/* <Loaders />
            <LoadingSpinner /> */}

            
                
                <div className="flapt-page-wrapper mainContent">
                    <Menus />

                    <div className="flapt-page-content">
                        <HeaderTop />

                        <div className="main-content introduction-farm mt--20">
                            <div className="content-wraper-area">
                                <div className="dashboard-area">
                                    <div className="container-fluid mb-90">
                                        <div className="card-header mb--30 mb-xs-10 ml-10">
                                            <h2>UnSubscription</h2>
                                        </div>
                                        {
                                        isLoading1 ?
                                        <LoadingSpinner />
                                        :
                                        <div className="row g-4">
                                            <div className="col-lg-12 col-md-12 pl-xs-0 pr-xs-0">
                                                <UnSubscriptionTable capitalizeWords={capitalizeWords} dataList={dataList} dataTotal={dataTotal} isLoading={isLoading} setIsLoading={setIsLoading} columns={columns} countPerPage={countPerPage} setPage={setPage} isFade={isFade} handleDuration={handleDuration} registerName={registerName} clearInputs={clearInputs} isAuthExpired={isAuthExpired} cpSelected={cpSelected} allCPs={allCPs} isLoading1={isLoading1} userSessions={allSessions} networkData={networkData} />
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <Footers />
                        </div>
                    </div>
                </div>
            
            

            
        </>
    );
}